import { createSlice } from "@reduxjs/toolkit";

export const newSeasonSelectedCrops = createSlice({
  name: "new-season-selected-crops",
  initialState: {
    value: {
      status: false,
      data: [],
      priorities: [
        { priority: "MAIN", label: "MAIN" },
        { priority: "SECONDARY", label: "SECOND" },
        { priority: "ADDITIONAL", label: "THIRD" },
      ],
    },
  },
  reducers: {
    updateNewSeasonSelectedCrops: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
    isMainCropExist: (state, action) => {
      const existingPriorities = state.value.priorities;
      const removeMain = existingPriorities.filter((item, index) => {
        return item.priority !== "MAIN";
      });
      state.value.priorities = removeMain;
    },
    isSecondaryCropExist: (state, action) => {
      const existingPriorities = state.value.priorities;
      const removeMain = existingPriorities.filter((item, index) => {
        return item.priority !== "SECONDARY";
      });
      state.value.priorities = removeMain;
    },
    isAdditionalCropExist: (state, action) => {
      const existingPriorities = state.value.priorities;
      const removeMain = existingPriorities.filter((item, index) => {
        return item.priority !== "ADDITIONAL";
      });
      state.value.priorities = removeMain;
    },
    resetPriorities: (state, action) => {
      state.value.priorities = [
        { priority: "MAIN", label: "MAIN" },
        { priority: "SECONDARY", label: "SECOND" },
        { priority: "ADDITIONAL", label: "THIRD" },
      ];
    },
    resetNewSeasonCrops: (state, action) => {
      state.value = {
        status: false,
        data: [],
        priorities: [
          { priority: "MAIN", label: "MAIN" },
          { priority: "SECONDARY", label: "SECOND" },
          { priority: "ADDITIONAL", label: "THIRD" },
        ],
      };
    },
  },
});

export const {
  updateNewSeasonSelectedCrops,
  isMainCropExist,
  isSecondaryCropExist,
  isAdditionalCropExist,
  resetPriorities,
  resetNewSeasonCrops,
} = newSeasonSelectedCrops.actions;

export default newSeasonSelectedCrops.reducer;
